import { usePrevious } from '@mantine/hooks'
import { useEffect } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router'
import { LOGIN_REDIRECT_TO_PARAM } from '@/components/login/useLoginRedirectTo'
import { useDocumentVisibleAfterDelay } from '@/hooks/useDocumentVisibleAfterDelay'
import { useSession } from '../session/SessionContext'
import { RouterPath } from './paths'

export const PrivateRoute = () => {
  const {
    isAuthenticated,
    isPasswordExpired,
    logoutState,
    user,
    refreshSession
  } = useSession()
  const location = useLocation()
  const previousUserId = usePrevious(user?.id)
  const navigate = useNavigate()

  useDocumentVisibleAfterDelay(() => {
    void refreshSession()
  }, 8000)

  useEffect(() => {
    if (previousUserId && user?.id && previousUserId !== user.id) {
      // Reload the page to clear the previous user's cache when logged in as a different user in another tab
      window.location.href = '/'
    }
  }, [previousUserId, user, navigate])

  if (isPasswordExpired) {
    return (
      <Navigate to={`${RouterPath.changePassword}?reason=expired`} replace />
    )
  }

  // Remember the user's intended URL for redirecting them there after they log in
  const currentPath = location.pathname + location.search

  const redirectToAfterLogin =
    logoutState?.redirectToAfterLogin ||
    (logoutState?.logoutType === 'initial_auth_check_failed' ? currentPath : '')

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: RouterPath.login,
          search:
            redirectToAfterLogin && redirectToAfterLogin !== '/'
              ? `?${LOGIN_REDIRECT_TO_PARAM}=${encodeURIComponent(redirectToAfterLogin)}`
              : ''
        }}
        replace
      />
    )
  }

  return <Outlet />
}
